import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\Editor\GetDocumentEditorController::__invoke
* @see app/Http/Controllers/Document/Editor/GetDocumentEditorController.php
* @route '/api/editor/{type}/{document}'
*/
const GetDocumentEditorController = (args: { type: string | number, document: string | number } | [type: string | number, document: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDocumentEditorController.url(args, options),
    method: 'get',
})

GetDocumentEditorController.definition = {
    methods: ["get","head"],
    url: '/api/editor/{type}/{document}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Document\Editor\GetDocumentEditorController::__invoke
* @see app/Http/Controllers/Document/Editor/GetDocumentEditorController.php
* @route '/api/editor/{type}/{document}'
*/
GetDocumentEditorController.url = (args: { type: string | number, document: string | number } | [type: string | number, document: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            document: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        document: args.document,
    }

    return GetDocumentEditorController.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{document}', parsedArgs.document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\Editor\GetDocumentEditorController::__invoke
* @see app/Http/Controllers/Document/Editor/GetDocumentEditorController.php
* @route '/api/editor/{type}/{document}'
*/
GetDocumentEditorController.get = (args: { type: string | number, document: string | number } | [type: string | number, document: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDocumentEditorController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Document\Editor\GetDocumentEditorController::__invoke
* @see app/Http/Controllers/Document/Editor/GetDocumentEditorController.php
* @route '/api/editor/{type}/{document}'
*/
GetDocumentEditorController.head = (args: { type: string | number, document: string | number } | [type: string | number, document: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDocumentEditorController.url(args, options),
    method: 'head',
})

export default GetDocumentEditorController